import {
	Box,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	Typography,
} from '@mui/material';
import { EasTooltip } from 'ui/EasTooltip';
import { FC } from 'react';
import { StyledTableCell, StyledTableRow } from 'ui/StyledTable';
import { UserAvatar } from 'ui/UserAvatar';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { getErrorCorrection } from 'redux/reducers/errorCorrections/selectors';
import { nanoid } from '@reduxjs/toolkit';
import { COLORS } from 'services/constants/colors';

export const ScriptsTable: FC = () => {
	const error = useSelector(getErrorCorrection);

	return (
		<Box
			sx={{
				border: `1px solid ${COLORS.BORDER}`,
				borderRadius: '12px',
			}}
		>
			<TableContainer>
				<Table>
					<TableHead>
						<StyledTableRow>
							<StyledTableCell
								sx={{
									borderRadius: '12px 0 0 0',
									p: '5px 10px',
								}}
							>
								Date
							</StyledTableCell>

							<StyledTableCell
								sx={{
									p: '5px 10px',
								}}
							>
								Script
							</StyledTableCell>
							<StyledTableCell
								sx={{
									p: '5px 10px',
								}}
							>
								Author
							</StyledTableCell>
							<StyledTableCell
								sx={{
									borderRadius: '0 12px 0 0',
									p: '5px 10px',
								}}
							>
								Result
							</StyledTableCell>
						</StyledTableRow>
					</TableHead>
					<TableBody>
						{error?.scriptHistory?.map(script => (
							<StyledTableRow key={nanoid()}>
								<StyledTableCell>
									{DateTime.fromISO(script.appliedAt).toFormat('yyyy-MM-dd')}
								</StyledTableCell>
								<StyledTableCell>
									<Typography
										component="div"
										sx={{
											borderRadius: '20px',
											padding: '3px 10px',
											backgroundColor: 'primary.main',
											color: COLORS.font_light,
											display: 'inline-block',
											fontSize: '0.8rem',
											opacity: 0.6,
										}}
									>
										{script.scriptName}
										{/* {script.script} */}
									</Typography>
								</StyledTableCell>
								<StyledTableCell>
									<UserAvatar user={script.appliedBy ?? null} size="xs" onClick={() => null} />
								</StyledTableCell>
								<StyledTableCell>
									<EasTooltip title={script?.message ?? ''}>
										<Box
											sx={{
												color:
													script.result === 'Failed'
														? 'error.main'
														: script.result === 'Exception'
															? 'warning.main'
															: 'success.main',
												fontWeight: 'bold',
											}}
										>
											{script.result}
										</Box>
									</EasTooltip>
								</StyledTableCell>
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};
